<div class="badge {{badge.color}}" [style.width]="width">
  {{badge.text}}
</div>
